// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  ConnectionRequestBody,
  GenericApiResponseConnectionView,
  GenericApiResponseGssOccasionPeopleResponse,
  GenericApiResponseListConnectionView,
  HTTPValidationError,
} from '../../models';

/**
 * @summary Get Gss Occasion People
 */
export const getGssOccasionPeople = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseGssOccasionPeopleResponse>> => {
  return axios.get(`/connections/occasions/gss/${slotId}`, options);
};

export const getGetGssOccasionPeopleQueryKey = (slotId: string) => {
  return [`/connections/occasions/gss/${slotId}`] as const;
};

export const getGetGssOccasionPeopleQueryOptions = <
  TData = Awaited<ReturnType<typeof getGssOccasionPeople>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGssOccasionPeople>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGssOccasionPeopleQueryKey(slotId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGssOccasionPeople>>> = ({ signal }) =>
    getGssOccasionPeople(slotId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!slotId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGssOccasionPeople>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGssOccasionPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof getGssOccasionPeople>>>;
export type GetGssOccasionPeopleQueryError = AxiosError<void | HTTPValidationError>;

export function useGetGssOccasionPeople<
  TData = Awaited<ReturnType<typeof getGssOccasionPeople>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGssOccasionPeople>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getGssOccasionPeople>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGssOccasionPeople<
  TData = Awaited<ReturnType<typeof getGssOccasionPeople>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGssOccasionPeople>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getGssOccasionPeople>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetGssOccasionPeople<
  TData = Awaited<ReturnType<typeof getGssOccasionPeople>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGssOccasionPeople>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Gss Occasion People
 */

export function useGetGssOccasionPeople<
  TData = Awaited<ReturnType<typeof getGssOccasionPeople>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGssOccasionPeople>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGssOccasionPeopleQueryOptions(slotId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Connections
 */
export const listConnections = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListConnectionView>> => {
  return axios.get(`/connections`, options);
};

export const getListConnectionsQueryKey = () => {
  return [`/connections`] as const;
};

export const getListConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListConnectionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnections>>> = ({ signal }) =>
    listConnections({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listConnections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listConnections>>>;
export type ListConnectionsQueryError = AxiosError<void>;

export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>, 'initialData'>;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>, 'initialData'>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Connections
 */

export function useListConnections<
  TData = Awaited<ReturnType<typeof listConnections>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListConnectionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Connection
 */
export const getConnection = (
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseConnectionView>> => {
  return axios.get(`/connections/${connectionId}`, options);
};

export const getGetConnectionQueryKey = (connectionId: string) => {
  return [`/connections/${connectionId}`] as const;
};

export const getGetConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  connectionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConnectionQueryKey(connectionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnection>>> = ({ signal }) =>
    getConnection(connectionId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!connectionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getConnection>>>;
export type GetConnectionQueryError = AxiosError<void | HTTPValidationError>;

export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  connectionId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  connectionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  connectionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Connection
 */

export function useGetConnection<
  TData = Awaited<ReturnType<typeof getConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  connectionId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnection>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetConnectionQueryOptions(connectionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Request Connection
 */
export const requestConnection = (
  connectionRequestBody: ConnectionRequestBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseConnectionView>> => {
  return axios.post(`/connections/request`, connectionRequestBody, options);
};

export const getRequestConnectionMutationOptions = <
  TData = Awaited<ReturnType<typeof requestConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ConnectionRequestBody }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['requestConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestConnection>>, { data: ConnectionRequestBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return requestConnection(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: ConnectionRequestBody },
    TContext
  >;
};

export type RequestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof requestConnection>>>;
export type RequestConnectionMutationBody = ConnectionRequestBody;
export type RequestConnectionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Request Connection
 */
export const useRequestConnection = <
  TData = Awaited<ReturnType<typeof requestConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: ConnectionRequestBody }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: ConnectionRequestBody }, TContext> => {
  const mutationOptions = getRequestConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Accept Connection
 */
export const acceptConnection = (
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseConnectionView>> => {
  return axios.post(`/connections/${connectionId}/accept`, undefined, options);
};

export const getAcceptConnectionMutationOptions = <
  TData = Awaited<ReturnType<typeof acceptConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['acceptConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptConnection>>, { connectionId: string }> = (
    props,
  ) => {
    const { connectionId } = props ?? {};

    return acceptConnection(connectionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
};

export type AcceptConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof acceptConnection>>>;

export type AcceptConnectionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Accept Connection
 */
export const useAcceptConnection = <
  TData = Awaited<ReturnType<typeof acceptConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { connectionId: string }, TContext> => {
  const mutationOptions = getAcceptConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Decline Connection
 */
export const declineConnection = (
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseConnectionView>> => {
  return axios.post(`/connections/${connectionId}/decline`, undefined, options);
};

export const getDeclineConnectionMutationOptions = <
  TData = Awaited<ReturnType<typeof declineConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['declineConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineConnection>>, { connectionId: string }> = (
    props,
  ) => {
    const { connectionId } = props ?? {};

    return declineConnection(connectionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
};

export type DeclineConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof declineConnection>>>;

export type DeclineConnectionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Decline Connection
 */
export const useDeclineConnection = <
  TData = Awaited<ReturnType<typeof declineConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { connectionId: string }, TContext> => {
  const mutationOptions = getDeclineConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Withdraw Connection
 */
export const withdrawConnection = (
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseConnectionView>> => {
  return axios.post(`/connections/${connectionId}/withdraw`, undefined, options);
};

export const getWithdrawConnectionMutationOptions = <
  TData = Awaited<ReturnType<typeof withdrawConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['withdrawConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawConnection>>, { connectionId: string }> = (
    props,
  ) => {
    const { connectionId } = props ?? {};

    return withdrawConnection(connectionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
};

export type WithdrawConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawConnection>>>;

export type WithdrawConnectionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Withdraw Connection
 */
export const useWithdrawConnection = <
  TData = Awaited<ReturnType<typeof withdrawConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { connectionId: string }, TContext> => {
  const mutationOptions = getWithdrawConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Remove Connection
 */
export const removeConnection = (
  connectionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseConnectionView>> => {
  return axios.post(`/connections/${connectionId}/remove`, undefined, options);
};

export const getRemoveConnectionMutationOptions = <
  TData = Awaited<ReturnType<typeof removeConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['removeConnection'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeConnection>>, { connectionId: string }> = (
    props,
  ) => {
    const { connectionId } = props ?? {};

    return removeConnection(connectionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
};

export type RemoveConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof removeConnection>>>;

export type RemoveConnectionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Remove Connection
 */
export const useRemoveConnection = <
  TData = Awaited<ReturnType<typeof removeConnection>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { connectionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { connectionId: string }, TContext> => {
  const mutationOptions = getRemoveConnectionMutationOptions(options);

  return useMutation(mutationOptions);
};
